import {useContext, useState} from 'react';
import useFormPersistence from './useFormPersistence';
import {LoopContext} from 'components/forms/context';
import get from 'lodash.get';
import set from 'lodash.set';

/**
 * Provide access to current value of form field state by name
 * @param {String} name Name of the field
 * @param {*} defaultValue Fallback value
 */
export default function useFieldData(name, defaultValue = '', loopPosition) {
    const {state, updateState} = useFormPersistence();

    let node = name;
    const looper = useContext(LoopContext);
    if (looper) {
        if (loopPosition === 'parent') {
            node = `${looper.parentNodePath}.${name}`;
        } else {
            node = `${looper.nodePath}[${looper.index}].${name}`;
        }
    }

    const [value, setValue] = useState(
        (state && get(state, node)) || defaultValue
    );

    const updateValue = value => {
        updateState(set(state, node, value));
        setValue(value);
    };

    return [value, updateValue];
}
